export default "__VITE_ASSET__PRZmBFWi__"